import {COUNTRIES, COUNTRY} from './env';

export const LABELS_MAP: Partial<Record<COUNTRIES, {name: string; short: string; icon: string}>> = {
    CAR: {
        name: 'Système numérique de suivi des marchandises',
        short: 'DigitalGate',
        icon: '/logo/logo_CAR.webp',
    },
    NG: {
        name: 'Digital Track and Trace for Governments',
        short: 'traceCORE',
        icon: '/logo/logo_NG.webp',
    },
};

export const LABELS = LABELS_MAP[COUNTRY] ?? LABELS_MAP.CAR!;
